import React from 'react'
import ReactHtmlParser from 'react-html-parser';

const { noResultsExtendedHtml, noResultsTitleExtendedHtml } = window['theme'].strings

const SearchNoResultBlock = (): JSX.Element => {
  return (
    <div className="sf-search-filtered-products-container no-results">
      <h3 className="heading-3">{ReactHtmlParser(noResultsTitleExtendedHtml)}</h3>
      <p>{ReactHtmlParser(noResultsExtendedHtml)}</p>
    </div>
  )
};

export default SearchNoResultBlock 